import styled from 'styled-components';
import flags from '../../../../../images/auth/flags.png';

export const PhoneInputWrapper = styled.div<{
  $hasError?: boolean;
  $width: number;
}>`
  position: relative;

  /* —-----------------— */

  .react-tel-input .ad {
    background-position: -49px -28px;
  }
  .react-tel-input .ae {
    background-position: -73px -28px;
  }
  .react-tel-input .af {
    background-position: -97px -28px;
  }
  .react-tel-input .ag {
    background-position: -121px -28px;
  }
  .react-tel-input .ai {
    background-position: -145px -28px;
  }
  .react-tel-input .al {
    background-position: -169px -28px;
  }
  .react-tel-input .am {
    background-position: -193px -28px;
  }
  .react-tel-input .an {
    background-position: -217px -28px;
  }
  .react-tel-input .ao {
    background-position: -241px -28px;
  }
  .react-tel-input .aq {
    background-position: -265px -28px;
  }
  .react-tel-input .ar {
    background-position: -289px -28px;
  }
  .react-tel-input .as {
    background-position: -313px -28px;
  }
  .react-tel-input .at {
    background-position: -337px -28px;
  }
  .react-tel-input .au {
    background-position: -361px -28px;
  }
  .react-tel-input .aw {
    background-position: -385px -28px;
  }

  /* —-----------------— */

  .react-tel-input .ax {
    background-position: -1px -52px;
  }
  .react-tel-input .az {
    background-position: -25px -52px;
  }
  .react-tel-input .ba {
    background-position: -49px -52px;
  }
  .react-tel-input .bb {
    background-position: -73px -52px;
  }
  .react-tel-input .bd {
    background-position: -97px -52px;
  }
  .react-tel-input .be {
    background-position: -121px -52px;
  }
  .react-tel-input .bf {
    background-position: -145px -52px;
  }
  .react-tel-input .bg {
    background-position: -169px -52px;
  }
  .react-tel-input .bh {
    background-position: -193px -52px;
  }
  .react-tel-input .bi {
    background-position: -217px -52px;
  }
  .react-tel-input .bj {
    background-position: -241px -52px;
  }
  .react-tel-input .bl {
    background-position: -265px -52px;
  }
  .react-tel-input .bm {
    background-position: -289px -52px;
  }
  .react-tel-input .bn {
    background-position: -313px -52px;
  }
  .react-tel-input .bo {
    background-position: -337px -52px;
  }
  .react-tel-input .br {
    background-position: -361px -52px;
  }
  .react-tel-input .bs {
    background-position: -385px -52px;
  }

  /* —-----------------— */

  .react-tel-input .bt {
    background-position: -1px -76px;
  }
  .react-tel-input .bw {
    background-position: -25px -76px;
  }
  .react-tel-input .by {
    background-position: -49px -76px;
  }
  .react-tel-input .bz {
    background-position: -73px -76px;
  }
  .react-tel-input .ca {
    background-position: -97px -76px;
  }
  .react-tel-input .cc {
    background-position: -121px -76px;
  }
  .react-tel-input .cd {
    background-position: -145px -76px;
  }
  .react-tel-input .cf {
    background-position: -169px -76px;
  }
  .react-tel-input .cg {
    background-position: -193px -76px;
  }
  .react-tel-input .ch {
    background-position: -217px -76px;
  }
  .react-tel-input .ci {
    background-position: -241px -76px;
  }
  .react-tel-input .ck {
    background-position: -265px -76px;
  }
  .react-tel-input .cl {
    background-position: -289px -76px;
  }
  .react-tel-input .cm {
    background-position: -313px -76px;
  }
  .react-tel-input .cn {
    background-position: -337px -76px;
  }
  .react-tel-input .co {
    background-position: -361px -76px;
  }
  .react-tel-input .cr {
    background-position: -385px -76px;
  }

  /* —-----------------— */

  .react-tel-input .cu {
    background-position: -1px -100px;
  }
  .react-tel-input .cv {
    background-position: -25px -100px;
  }
  .react-tel-input .cw {
    background-position: -49px -100px;
  }
  .react-tel-input .cx {
    background-position: -73px -100px;
  }
  .react-tel-input .cy {
    background-position: -97px -100px;
  }
  .react-tel-input .cz {
    background-position: -121px -100px;
  }
  .react-tel-input .de {
    background-position: -145px -100px;
  }
  .react-tel-input .dj {
    background-position: -169px -100px;
  }
  .react-tel-input .dk {
    background-position: -193px -100px;
  }
  .react-tel-input .dm {
    background-position: -217px -100px;
  }
  .react-tel-input .do {
    background-position: -241px -100px;
  }
  .react-tel-input .dz {
    background-position: -265px -100px;
  }
  .react-tel-input .ec {
    background-position: -289px -100px;
  }
  .react-tel-input .ee {
    background-position: -313px -100px;
  }
  .react-tel-input .eg {
    background-position: -337px -100px;
  }
  .react-tel-input .eh {
    background-position: -361px -100px;
  }
  .react-tel-input .er {
    background-position: -385px -100px;
  }

  /* —-----------------— */

  .react-tel-input .es {
    background-position: -1px -124px;
  }
  .react-tel-input .et {
    background-position: -25px -124px;
  }
  .react-tel-input .eu {
    background-position: -49px -124px;
  }
  .react-tel-input .fi {
    background-position: -73px -124px;
  }
  .react-tel-input .fj {
    background-position: -97px -124px;
  }
  .react-tel-input .fk {
    background-position: -121px -124px;
  }
  .react-tel-input .fm {
    background-position: -145px -124px;
  }
  .react-tel-input .fo {
    background-position: -169px -124px;
  }
  .react-tel-input .fr {
    background-position: -193px -124px;
  }
  .react-tel-input .ga {
    background-position: -217px -124px;
  }
  .react-tel-input .gb {
    background-position: -241px -124px;
  }
  .react-tel-input .gd {
    background-position: -265px -124px;
  }
  .react-tel-input .ge {
    background-position: -289px -124px;
  }
  .react-tel-input .gg {
    background-position: -313px -124px;
  }
  .react-tel-input .gh {
    background-position: -337px -124px;
  }
  .react-tel-input .gi {
    background-position: -361px -124px;
  }
  .react-tel-input .gl {
    background-position: -385px -124px;
  }

  /* —-----------------— */

  .react-tel-input .gm {
    background-position: -1px -148px;
  }
  .react-tel-input .gn {
    background-position: -25px -148px;
  }
  .react-tel-input .gq {
    background-position: -49px -148px;
  }
  .react-tel-input .gr {
    background-position: -73px -148px;
  }
  .react-tel-input .gs {
    background-position: -97px -148px;
  }
  .react-tel-input .gt {
    background-position: -121px -148px;
  }
  .react-tel-input .gu {
    background-position: -145px -148px;
  }
  .react-tel-input .gw {
    background-position: -169px -148px;
  }
  .react-tel-input .gy {
    background-position: -193px -148px;
  }
  .react-tel-input .hk {
    background-position: -217px -148px;
  }
  .react-tel-input .hn {
    background-position: -241px -148px;
  }
  .react-tel-input .hr {
    background-position: -265px -148px;
  }
  .react-tel-input .ht {
    background-position: -289px -148px;
  }
  .react-tel-input .hu {
    background-position: -313px -148px;
  }
  .react-tel-input .ic {
    background-position: -337px -148px;
  }
  .react-tel-input .id {
    background-position: -361px -148px;
  }
  .react-tel-input .ie {
    background-position: -385px -148px;
  }

  /* —-----------------— */

  .react-tel-input .il {
    background-position: -1px -172px;
  }
  .react-tel-input .im {
    background-position: -25px -172px;
  }
  .react-tel-input .in {
    background-position: -49px -172px;
  }
  .react-tel-input .iq {
    background-position: -73px -172px;
  }
  .react-tel-input .ir {
    background-position: -97px -172px;
  }
  .react-tel-input .is {
    background-position: -121px -172px;
  }
  .react-tel-input .it {
    background-position: -145px -172px;
  }
  .react-tel-input .je {
    background-position: -169px -172px;
  }
  .react-tel-input .jm {
    background-position: -193px -172px;
  }
  .react-tel-input .jo {
    background-position: -217px -172px;
  }
  .react-tel-input .jp {
    background-position: -241px -172px;
  }
  .react-tel-input .ke {
    background-position: -265px -172px;
  }
  .react-tel-input .kg {
    background-position: -289px -172px;
  }
  .react-tel-input .kh {
    background-position: -313px -172px;
  }
  .react-tel-input .ki {
    background-position: -337px -172px;
  }
  .react-tel-input .xk {
    background-position: -145px -4px;
  }
  .react-tel-input .km {
    background-position: -361px -172px;
  }
  .react-tel-input .kn {
    background-position: -385px -172px;
  }

  /* —-----------------— */

  .react-tel-input .kp {
    background-position: -1px -196px;
  }
  .react-tel-input .kr {
    background-position: -25px -196px;
  }
  .react-tel-input .kw {
    background-position: -49px -196px;
  }
  .react-tel-input .ky {
    background-position: -73px -196px;
  }
  .react-tel-input .kz {
    background-position: -97px -196px;
  }
  .react-tel-input .la {
    background-position: -121px -196px;
  }
  .react-tel-input .lb {
    background-position: -145px -196px;
  }
  .react-tel-input .lc {
    background-position: -169px -196px;
  }
  .react-tel-input .li {
    background-position: -193px -196px;
  }
  .react-tel-input .lk {
    background-position: -217px -196px;
  }
  .react-tel-input .lr {
    background-position: -241px -196px;
  }
  .react-tel-input .ls {
    background-position: -265px -196px;
  }
  .react-tel-input .lt {
    background-position: -289px -196px;
  }
  .react-tel-input .lu {
    background-position: -313px -196px;
  }
  .react-tel-input .lv {
    background-position: -337px -196px;
  }
  .react-tel-input .ly {
    background-position: -361px -196px;
  }
  .react-tel-input .ma {
    background-position: -385px -196px;
  }

  /* —-----------------— */

  .react-tel-input .mc {
    background-position: -1px -220px;
  }
  .react-tel-input .md {
    background-position: -25px -220px;
  }
  .react-tel-input .me {
    background-position: -49px -220px;
  }
  .react-tel-input .mf {
    background-position: -73px -220px;
  }
  .react-tel-input .mg {
    background-position: -97px -220px;
  }
  .react-tel-input .mh {
    background-position: -121px -220px;
  }
  .react-tel-input .mk {
    background-position: -145px -220px;
  }
  .react-tel-input .ml {
    background-position: -169px -220px;
  }
  .react-tel-input .mm {
    background-position: -193px -220px;
  }
  .react-tel-input .mn {
    background-position: -217px -220px;
  }
  .react-tel-input .mo {
    background-position: -241px -220px;
  }
  .react-tel-input .mp {
    background-position: -265px -220px;
  }
  .react-tel-input .mq {
    background-position: -289px -220px;
  }
  .react-tel-input .mr {
    background-position: -313px -220px;
  }
  .react-tel-input .ms {
    background-position: -337px -220px;
  }
  .react-tel-input .mt {
    background-position: -361px -220px;
  }
  .react-tel-input .mu {
    background-position: -385px -220px;
  }

  /* —-----------------— */

  .react-tel-input .mv {
    background-position: -1px -244px;
  }
  .react-tel-input .mw {
    background-position: -25px -244px;
  }
  .react-tel-input .mx {
    background-position: -49px -244px;
  }
  .react-tel-input .my {
    background-position: -73px -244px;
  }
  .react-tel-input .mz {
    background-position: -97px -244px;
  }
  .react-tel-input .na {
    background-position: -121px -244px;
  }
  .react-tel-input .nc {
    background-position: -145px -244px;
  }
  .react-tel-input .ne {
    background-position: -169px -244px;
  }
  .react-tel-input .nf {
    background-position: -193px -244px;
  }
  .react-tel-input .ng {
    background-position: -217px -244px;
  }
  .react-tel-input .ni {
    background-position: -241px -244px;
  }
  .react-tel-input .nl {
    background-position: -265px -244px;
  }
  .react-tel-input .no {
    background-position: -289px -244px;
  }
  .react-tel-input .np {
    background-position: -313px -244px;
  }
  .react-tel-input .nr {
    background-position: -337px -244px;
  }
  .react-tel-input .nu {
    background-position: -361px -244px;
  }
  .react-tel-input .nz {
    background-position: -385px -244px;
  }

  /* —-----------------— */

  .react-tel-input .om {
    background-position: -1px -268px;
  }
  .react-tel-input .pa {
    background-position: -25px -268px;
  }
  .react-tel-input .pe {
    background-position: -49px -268px;
  }
  .react-tel-input .pf {
    background-position: -73px -268px;
  }
  .react-tel-input .pg {
    background-position: -97px -268px;
  }
  .react-tel-input .ph {
    background-position: -121px -268px;
  }
  .react-tel-input .pk {
    background-position: -193px -268px;
  }
  .react-tel-input .pl {
    background-position: -217px -268px;
  }
  .react-tel-input .pn {
    background-position: -241px -268px;
  }
  .react-tel-input .pr {
    background-position: -265px -268px;
  }
  .react-tel-input .ps {
    background-position: -289px -268px;
  }
  .react-tel-input .pt {
    background-position: -313px -268px;
  }
  .react-tel-input .pw {
    background-position: -337px -268px;
  }
  .react-tel-input .py {
    background-position: -361px -268px;
  }
  .react-tel-input .qa {
    background-position: -385px -268px;
  }

  /* —-----------------— */
  .react-tel-input .ro {
    background-position: -1px -292px;
  }
  .react-tel-input .rs {
    background-position: -25px -292px;
  }
  .react-tel-input .ru {
    background-position: -49px -292px;
  }
  .react-tel-input .rw {
    background-position: -73px -292px;
  }
  .react-tel-input .sa {
    background-position: -97px -292px;
  }
  .react-tel-input .sb {
    background-position: -121px -292px;
  }
  .react-tel-input .sc {
    background-position: -145px -292px;
  }
  .react-tel-input .sd {
    background-position: -169px -292px;
  }
  .react-tel-input .se {
    background-position: -193px -292px;
  }
  .react-tel-input .sg {
    background-position: -217px -292px;
  }
  .react-tel-input .sh {
    background-position: -241px -292px;
  }
  .react-tel-input .si {
    background-position: -265px -292px;
  }
  .react-tel-input .sk {
    background-position: -289px -292px;
  }
  .react-tel-input .sl {
    background-position: -313px -292px;
  }
  .react-tel-input .sm {
    background-position: -337px -292px;
  }
  .react-tel-input .sn {
    background-position: -361px -292px;
  }
  .react-tel-input .so {
    background-position: -385px -292px;
  }

  /* —-----------------— */

  .react-tel-input .sr {
    background-position: -1px -316px;
  }
  .react-tel-input .ss {
    background-position: -25px -316px;
  }
  .react-tel-input .st {
    background-position: -49px -316px;
  }
  .react-tel-input .sv {
    background-position: -73px -316px;
  }
  .react-tel-input .sy {
    background-position: -97px -316px;
  }
  .react-tel-input .sz {
    background-position: -121px -316px;
  }
  .react-tel-input .tc {
    background-position: -145px -316px;
  }
  .react-tel-input .td {
    background-position: -169px -316px;
  }
  .react-tel-input .tf {
    background-position: -193px -316px;
  }
  .react-tel-input .tg {
    background-position: -217px -316px;
  }
  .react-tel-input .th {
    background-position: -241px -316px;
  }
  .react-tel-input .tj {
    background-position: -265px -316px;
  }
  .react-tel-input .tk {
    background-position: -289px -316px;
  }
  .react-tel-input .tl {
    background-position: -313px -316px;
  }
  .react-tel-input .tm {
    background-position: -337px -316px;
  }
  .react-tel-input .tn {
    background-position: -361px -316px;
  }
  .react-tel-input .to {
    background-position: -385px -316px;
  }

  /* —-----------------— */

  .react-tel-input .tr {
    background-position: -1px -340px;
  }
  .react-tel-input .tt {
    background-position: -25px -340px;
  }
  .react-tel-input .tv {
    background-position: -49px -340px;
  }
  .react-tel-input .tw {
    background-position: -73px -340px;
  }
  .react-tel-input .tz {
    background-position: -97px -340px;
  }
  .react-tel-input .ua {
    background-position: -121px -340px;
  }
  .react-tel-input .ug {
    background-position: -145px -340px;
  }
  .react-tel-input .us {
    background-position: -169px -340px;
  }
  .react-tel-input .uy {
    background-position: -193px -340px;
  }
  .react-tel-input .uz {
    background-position: -217px -340px;
  }
  .react-tel-input .va {
    background-position: -241px -340px;
  }
  .react-tel-input .vc {
    background-position: -265px -340px;
  }
  .react-tel-input .ve {
    background-position: -289px -340px;
  }
  .react-tel-input .vg {
    background-position: -313px -340px;
  }
  .react-tel-input .vi {
    background-position: -337px -340px;
  }
  .react-tel-input .vn {
    background-position: -361px -340px;
  }
  .react-tel-input .vu {
    background-position: -385px -340px;
  }

  /* —-----------------— */

  .react-tel-input .wf {
    background-position: -1px -364px;
  }
  .react-tel-input .ws {
    background-position: -25px -364px;
  }
  .react-tel-input .ye {
    background-position: -49px -364px;
  }
  .react-tel-input .za {
    background-position: -97px -364px;
  }
  .react-tel-input .zm {
    background-position: -121px -364px;
  }
  .react-tel-input .zw {
    background-position: -145px -364px;
  }
  .react-tel-input * {
    box-sizing: border-box;
    -moz-box-sizing: border-box;
  }
  .react-tel-input .hide {
    display: none;
  }
  .react-tel-input .v-hide {
    visibility: hidden;
  }
  .react-tel-input {
    font-family: 'ONYOneFont', 'Helvetica', sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    position: relative;
    width: 100%;
    border-radius: var(--border-radius);
  }
  .react-tel-input :disabled {
    cursor: not-allowed;
    opacity: var(--disabled-opacity);
  }
  .react-tel-input .form-control {
    -moz-appearance: none;
    -webkit-appearance: none;

    position: relative;
    letter-spacing: 0.01rem;
    margin-top: 0 !important;
    padding-left: 60px;
    margin-left: 0;
    background: var(--white);
    border: 1px solid var(--grey3);
    border-radius: var(--border-radius);
    outline: none;
    width: 100%;
    height: 50px;
    font-family: inherit;
    font-size: 14px;
    font-weight: 700;
    line-height: 16px;

    &:focus {
      border: 1px solid var(--black);
    }

    &:disabled {
      background: #f5f3f2;
    }

    ${({ $hasError }) => $hasError && 'border: 1px solid var(--orange)'};
  }

  .react-tel-input .flag-dropdown {
    position: absolute;
    background-color: transparent;
    width: 56px;
    outline: none;
    border-radius: var(--border-radius) 0px 0px var(--border-radius);
    height: 50px;
    border: 1px solid;
    border-right: none;
    height: 48px;
    border: none;
    margin: -49px 0 0 1px;
  }
  .react-tel-input .flag-dropdown:hover,
  .react-tel-input .flag-dropdown:focus {
    cursor: pointer;
  }
  .react-tel-input .flag-dropdown.invalid-number {
    margin: -69px 0 20px 1px;
  }
  .react-tel-input .flag-dropdown.open {
    z-index: 2;
  }
  .react-tel-input input[disabled] + .flag-dropdown:hover {
    cursor: default;
  }
  .react-tel-input input[disabled] + .flag-dropdown:hover .selected-flag {
    background: #f5f3f2;
  }
  .react-tel-input .selected-flag {
    outline: none;
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0 0 0 8px;
    border-radius: var(--border-radius) 0px 0px var(--border-radius);
    background: transparent;
  }
  .react-tel-input .selected-flag .flag {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translate(8px, -50%);
  }
  .react-tel-input .selected-flag .arrow {
    position: relative;
    top: 50%;
    transform: translate(0, -50%);
    left: 28px;
    width: 0;
    height: 0;
    border-left: 3px solid transparent;
    border-right: 3px solid transparent;
    border-top: 4px solid #555;
  }
  .react-tel-input .selected-flag .arrow.up {
    border-top: none;
    border-bottom: 4px solid #555;
  }
  .react-tel-input .country-list {
    outline: none;
    z-index: 1;
    list-style: none;
    position: absolute;
    padding: 0;
    margin: 10px 0 10px -1px;
    box-shadow: 1px 2px 10px rgba(0, 0, 0, 0.35);
    background-color: white;
    width: ${({ $width }) => `${$width}px`};
    max-height: 230px;
    overflow-y: scroll;
    border-radius: 0 0 3px 3px;

    & li {
      text-align: left;
      display: flex;
      align-items: center;
      font-size: 15px;
    }
  }
  input[type='search']::-webkit-search-decoration {
    display: none;
  }

  .react-tel-input .country-list .flag {
    display: inline-block;
  }
  .react-tel-input .country-list .divider {
    padding-bottom: 5px;
    margin-bottom: 5px;
    border-bottom: 1px solid #ccc;
  }
  .react-tel-input .country-list .country {
    padding: 7px 9px;
  }
  .react-tel-input .country-list .country .dial-code {
    color: #6b6b6b;
    margin-left: auto;
  }
  .react-tel-input .country-list .country:hover {
    background-color: #f1f1f1;
  }
  .react-tel-input .country-list .country.highlight {
    background-color: #f1f1f1;
  }
  .react-tel-input .country-list .flag {
    min-width: 22px;
    margin-right: 7px;
    margin-bottom: 2px;
  }
  .react-tel-input .country-list .country-name {
    margin-right: 6px;
    margin-left: 8px;
  }
  .react-tel-input .country-list .search {
    -moz-appearance: none;
    -webkit-appearance: none;
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    background-color: #fff;
    padding: 10px;
    display: flex;
    align-items: center;
    width: 100%;

    // иконка лупы
    &:before {
      position: absolute;
      content: '';
      width: 24px;
      height: 24px;
      display: block;
      background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGPSURBVHgB7ZRfTsJAEMZnZkvjgw8egRtAE2PSaISewHiCygnoDYQbwBE4gdxgVcAmQlKOwBF41XRn3SUxiqHtqhgT45f0Zf/Mbzo73wD867eFRRtSZkfeAXeZ4QpB1+2aBlgi4FI9Uz+KghU4iHYtTtMsJp8zzhmZuXN+eoz2Y80drRUKX2V3D/MEvvIHk9miy6ATJi+Kwt1ZyjStE/sSiHqtMBiBK0DKtC5qtUwJERQFfw8R2pPqyQtMudZF57ZKRDXRA8RxVXCrKAxXWsGI/Ly0VNsApIbSagiOYoBbBIpdz8P9bKHhk6q6Q/DD+gDAlZzM2+AoOX1sWm84AzTziAja4J5dYo1XceZNnHsDRIiNi+tQIdvS5vqFIuo7A2w/K9Z94eeyDLLxi2+MhnpY1dI7Z5GczhOBeG22x7Zto7OTTRns+3getex8AlNOFBCbhC5f950Bm2B2HChjPKCGKVvTrmnTBDYwH3qDKAjW9pEF4U0ZpBDgqirItwFVkL0AyiB7c7INaoMTYBv+lF4AjFLDVnjUDJ4AAAAASUVORK5CYII=');
      transform: translate(8px, -50%);
      top: 50%;
      z-index: 9;
    }
  }
  .react-tel-input .country-list .search-box {
    -moz-appearance: none;
    -webkit-appearance: none;

    background-color: transparent;
    font-size: 15px;
    line-height: 15px;
    outline: none;
    width: 100%;
    border: 1px solid var(--grey3);
    border-radius: var(--border-radius);
    font-family: inherit;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    padding: 8px 8px 8px 38px;
    color: var(--black);
    position: relative;
  }
  [type='search']::-webkit-search-cancel-button {
    cursor: pointer;
  }
  .react-tel-input .country-list .no-entries-message {
    padding: 7px 10px 11px;
    opacity: 0.7;
  }
  .react-tel-input .invalid-number-message {
    position: absolute;
    z-index: 1;
    font-size: 13px;
    left: 0;
    top: 52px;
    background: transparent;
    padding: 0 2px;
    color: var(--orange);
    max-width: -webkit-fit-content;
    max-width: -moz-fit-content;
    max-width: fit-content;
  }
  .react-tel-input .special-label {
    display: none;
    position: absolute;
    z-index: 1;
    font-size: 13px;
    left: 46px;
    top: -8px;
    background: #fff;
    padding: 0 2px;
    white-space: nowrap;
  }

  .react-tel-input .flag {
    width: 22px;
    height: 16px;
    box-sizing: content-box;
    background-size: auto;
    background-image: url(${flags});
    background-repeat: no-repeat;
    border: 0.7px solid #e8e8e8;
  }
`;
